<template>
  <md-table-row
    :class="{
      'table-info': value.label.toLowerCase() == 'magic price',
      'table-info': value.editable == true,
    }"
  >
    <md-table-cell class="h6 first-row" :title="value.label">
      <md-checkbox
        v-if="value.editable"
        class="m-0 checkbox-edited-by-user"
        @change="toggleRow($event, 'channel-editable-' + value.label.toLowerCase())"
        v-model="value.selected"
      ></md-checkbox>
      {{ value.label }}
    </md-table-cell>
    <md-table-cell
      :class="{
        'bg-saved': visibleColumns[index].saved,
      }"
      v-for="(cell, index) in visibleColumns"
      :key="'cell_' + index"
      md-label="ID"
    >
      <!-- solo es editable si es la fila de override(enviado desde el back), el componente nunca va a tener un valor recomendado -->
      <template v-if="value.editable">
        <pricing-table-editable-element
          :ref="'channel-editable-' + value.label.toLowerCase()"
          :value="cell.value"
          @change="toggleColumn($event, index, true)"
          :symbol="simbol"
        >
        </pricing-table-editable-element>
      </template>
      <template v-if="!value.editable && cell.value.amount > 0">
        <span class="amount">{{ getPriceWithDecimals(cell.value.amount) }} {{ simbol }}</span>
      </template>
    </md-table-cell>
  </md-table-row>
</template>

<script>
/*eslint-disable */

import PricingTableEditableElement from './PricingTableEditableElement.vue'
import Currency from '@/utils/Currency'

export default {
  components: { PricingTableEditableElement },
  name: 'PricingTableNonHideableRow',
  props: {
    value: Object,
    allotmentRows: Array,
  },
  methods: {
    toggleRow(selected) {
      this.value.data.forEach((element) => {
        const actual = element.value
        this.$set(actual, 'selected', selected)
      })
    },
    toggleColumn(selected, index, override) {
      this.$emit('toggleColumn', selected, index, override)
    },
    getPriceWithDecimals(value) {
      let showDecimals = sessionStorage.getItem('show-decimals')
      if (showDecimals === 'false') {
        let aux = value
        if (typeof value === 'number') {
          aux = value.toString()
        }
        return aux.split('.')[0]
      } else {
        return value
      }
    },
  },
  computed: {
    visibleColumns() {
      return this.value.data
    },
    simbol() {
      if (this.value.symbol.indexOf('€') >= 0) {
        return this.value.symbol.replace('€', Currency[sessionStorage.getItem('currency')])
      } else {
        return this.value.symbol
      }
    },
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss">
@import 'src/assets/scss/md/_variables.scss';
.md-table-cell .md-checkbox {
  zoom: 0.7;
}

.md-table .md-table-row:hover .md-table-cell.bg-open,
.bg-open {
  background-color: white !important;
}

.md-table .md-table-row:hover .md-table-cell.bg-closed,
.bg-closed {
  background: repeating-linear-gradient(#f2d7b4, #f2d7b4) !important;
}

.md-table .md-table-row:hover .md-table-cell.bg-partial,
.bg-partial {
  background: repeating-linear-gradient(45deg, rgb(247, 231, 209) 10px, rgb(252, 246, 238) 10px, rgb(242, 215, 180) 20px) !important;
}
.md-table .md-table-row:hover .md-table-cell.bg-saved,
.bg-saved {
  background: repeating-linear-gradient($brand-saved, $brand-saved) !important;
}
</style>
}
